import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';
import {
    buttonClassName,
    labelClassName,
    pxToRem,
} from '@fluentui/react-northstar';

export const DeleteBoardModalContainer: StyleRule = ({ theme }) => ({
    height: pxToRem(225),
    padding: pxArrayToRem([20, 21, 0]),

    [theme.screen.tablet]: {
        height: pxToRem(226),
        padding: pxArrayToRem([36, 24, 0]),
    },
});

export const DeleteBoardHeader: StyleRule = ({ theme }) => ({
    ...theme.siteVariables.textStyles.Text.Medium65,
    fontSize: pxToRem(20),
    letterSpacing: pxToRem(-0.4),
    marginBottom: pxToRem(32),

    [theme.screen.tablet]: {
        fontSize: pxToRem(22),
    },
});

export const DeleteBoardMessage: StyleRule = () => ({
    fontSize: pxToRem(16),
    marginBottom: pxToRem(34),
    lineHeight: 1.3,
});

export const DeleteBoardModalButtonContainer: StyleRule = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row-reverse',

    [`& .${buttonClassName}`]: {
        padding: pxArrayToRem([17.5, 0]),
        marginLeft: pxToRem(8),
        width: pxToRem(143),
        borderColor: theme.siteVariables.colors.charcoal['000'],
    },

    [`& .${labelClassName}`]: {
        fontSize: pxToRem(16),
    },
});
